const Page404: React.FC = () => (
  <div>
    <h1>Not Found</h1>
  </div>
);

export default Page404;
